import React from 'react';
import PropTypes from 'prop-types';

/**
 * The default button is a medium button, as per the
 * default value of buttonClassName: 'button--medium'
 */
const Button = ({
  id = null,
  as,
  children,
  buttonClassName = 'button--medium',
  extraClassName = '',
  href = null,
  onClick = null,
  type = null,
}) => {
  const Component = as;
  const classString = `button ${buttonClassName} ${extraClassName}`;

  return (
    <Component id={id} href={href} type={type} className={classString} onClick={onClick}>
      {children}
    </Component>
  );
};

Button.propTypes = {
  id: PropTypes.string,
  as: PropTypes.oneOf(['a', 'button']).isRequired,
  children: PropTypes.node.isRequired,
  // if the Button is an `a` element, it needs to have an href attribute
  href: (props, propName) => {
    const { as, [propName]: prop } = props;
    if (as === 'a' && (typeof prop === 'undefined' || typeof prop !== 'string')) {
      return new Error('Please provide an href as a String for Button as a');
    }
    return null;
  },
  buttonClassName: PropTypes.string,
  extraClassName: PropTypes.string,
  onClick: PropTypes.func,
  // if the Button is a `button` element, it needs to have a type attribute
  type: (props, propName) => {
    const { as, [propName]: prop } = props;
    if (as === 'button' && (typeof prop === 'undefined' || typeof prop !== 'string') && (prop !== 'button' || prop !== 'submit')) {
      return new Error('Please provide a type as a String for Button as button');
    }
    return null;
  },
};

export default Button;
